var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.LS.Header.PNResponsiveMenu = (function() {
  function PNResponsiveMenu() {
    this.getVisibility = bind(this.getVisibility, this);
    this.bind = bind(this.bind, this);
    this.unbind = bind(this.unbind, this);
    this.alterDOM = bind(this.alterDOM, this);
    this.constructLanguageMenu = bind(this.constructLanguageMenu, this);
    this.constructUserMenu = bind(this.constructUserMenu, this);
    this.constructUserNavigation = bind(this.constructUserNavigation, this);
    this.initialize = bind(this.initialize, this);
    var $primaryNav, $userNav;
    this.initialize();
    this.unbind();
    this.$subnavs = this.constructSubNavFlyouts();
    $primaryNav = this.constructPrimaryNavigation(this.$subnavs);
    $userNav = this.constructUserNavigation(this.constructUserMenu(), this.constructLanguageMenu());
    this.$menu.append($primaryNav, $userNav);
    this.dedupIDs();
    this.alterDOM();
    this.bind();
  }

  PNResponsiveMenu.prototype.initialize = function() {
    this.$menu = $('#ls-resp-menu');
    this.$body = $('body');
    this.$headerRow = $('#ls-header-top-row');
    this.$overlay = $('#ls-resp-overlay');
    this.$searchBar = $('#ls-search-bar-wrapper');
    this.$userMenu = $('#ls-my-stuff');
    this.$responsiveMenuWrapper = $('#ls-resp-menu-wrapper');
    this.greenHeader = $('.ui-v3').length;
    this.popoverActiveClass = 'responsive-show-500';
    this.popoverTriggerActiveClass = 'ls-resp-active';
    this.$menuTrigger = $('#ls-resp-menu-trigger');
    this.$searchTrigger = $('#ls-resp-search-trigger');
    return this.$backButton = $('#ls-resp-back-button');
  };

  PNResponsiveMenu.prototype.constructPrimaryNavigation = function(subNavs) {
    var $primaryNav;
    $primaryNav = $('#ls-channel-nav li:not(li.p-nav-divider,li.ls-exclude-resp-nav)').clone().attr({
      role: 'menuitem',
      style: null,
      "class": 'ls-resp-menu-item'
    }).each(function() {
      var $this, i, id, len, subnav;
      id = 'subnav-' + this.id;
      for (i = 0, len = subNavs.length; i < len; i++) {
        subnav = subNavs[i];
        if (subnav.id === id && subnav.children.length) {
          subnav.id = 'ls-resp-' + this.id.replace('-tab', '-menu');
          $(subnav).attr({
            'aria-labelled': null,
            'aria-labelledby': null,
            'aria-hidden': null
          });
          $this = $(this);
          $this.children('a').attr({
            id: null,
            role: null,
            tabindex: null,
            'aria-haspopup': null,
            'aria-owns': null
          });
          $this.addClass('icon-arrow-down-large').append(subnav);
        }
      }
      return this.id = 'ls-resp-' + this.id.replace('-tab', '-trigger');
    });
    $primaryNav.find('.icon-home').removeClass();
    $primaryNav = $primaryNav.map(function() {
      var $subnav, $this;
      $this = $(this);
      $subnav = $this.find('.ls-resp-submenu');
      if (!$subnav.find('a').length) {
        $subnav.remove();
        $this.removeClass('icon-arrow-down-large');
      }
      return this;
    });
    return $primaryNav;
  };

  PNResponsiveMenu.prototype.constructSubNavFlyouts = function() {
    var $subNavs;
    $subNavs = $('.subnav-flyout').clone().attr({
      'aria-hidden': 'true',
      role: 'menu',
      "class": 'ls-resp-submenu hide',
      style: null
    });
    $subNavs.find('.subnav-megamind, .subnav-cardatron').remove();
    $subNavs.find('.subnav-header').remove();
    $subNavs.find('.subnav-top-categories').remove();
    $subNavs.find('.ls-exclude-resp-sub-nav').remove();
    $subNavs.find('.subnav-link').addClass('ls-resp-submenu-item').unwrap();
    $subNavs.find('.two-column .subnav-link').unwrap().unwrap();
    return $subNavs;
  };

  PNResponsiveMenu.prototype.constructUserNavigation = function($userMenu, $langMenu) {
    var $cart, $signOut, $userName, $userNav;
    $userNav = $('.ls-user-item, .user-menu-item').clone().wrap('<li class="ls-resp-menu-item"></li>').parent();
    if ($langMenu.length) {
      $userNav = $langMenu.add($userNav);
    }
    if (($userName = $userNav.find('.user-name')).length) {
      $userName.attr({
        href: null,
        id: 'ls-resp-user-name',
        "class": 'icon-user',
        role: null,
        tabindex: null,
        'aria-haspopup': null,
        'aria-owns': null,
        'aria-describedby': null
      }).text($userName.attr('data-user-name')).parent().attr({
        id: 'subnav-usermenu-menu',
        "class": 'ls-resp-menu-item ls-resp-menu-item-user icon-arrow-down-large'
      }).append($userMenu);
      $signOut = this.$userMenu.find('#sign-out').clone().attr({
        "class": null
      }).wrap('<li class="ls-resp-menu-item"></li>').parent();
      $userNav = $userNav.add($signOut);
    }
    if (($cart = $userNav.find('.cart-widget')).length) {
      $cart = $cart.find('a');
      $userNav.find('.cart-widget').replaceWith($cart);
    }
    $userNav.find('.ls-user-item, .user-menu-item').removeClass();
    $userNav.eq(0).addClass('ls-resp-menu-divider');
    return $userNav;
  };

  PNResponsiveMenu.prototype.constructUserMenu = function() {
    var $userMenu;
    $userMenu = {};
    if (this.$userMenu.length) {
      $userMenu = this.$userMenu.clone().attr({
        "class": 'ls-resp-submenu hide',
        id: 'ls-resp-user-menu',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $userMenu.find('#sign-out').remove();
      $userMenu.find('a').addClass('ls-resp-submenu-item').each(function() {
        return this.id = 'ls-resp-' + this.id;
      });
      this.$subnavs = this.$subnavs.add($userMenu);
    }
    return $userMenu;
  };

  PNResponsiveMenu.prototype.constructLanguageMenu = function() {
    var $langMenu, $langMenuSelector;
    $langMenuSelector = {};
    if ($('.lang-menu').length) {
      $langMenuSelector = $('<span />').text($('#ls-lang-selected').text().trim()).wrap('<li></li>').parent().attr({
        id: 'ls-resp-lang-trigger',
        "class": 'ls-resp-menu-item ls-resp-lang-trigger icon-arrow-down-large'
      });
      $langMenu = $('#ls-lang-list').clone().attr({
        id: 'ls-resp-lang-menu',
        "class": 'ls-resp-submenu hide',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $langMenu.find('a').addClass('ls-resp-submenu-item');
      $langMenuSelector.append($langMenu);
      this.$subnavs = this.$subnavs.add($langMenu);
    }
    return $langMenuSelector;
  };

  PNResponsiveMenu.prototype.dedupIDs = function() {
    return this.$responsiveMenuWrapper.find('*[id]').each(function() {
      if (!this.id.match(/ls-resp-/)) {
        return this.id = "ls-resp-" + this.id;
      }
    });
  };

  PNResponsiveMenu.prototype.alterDOM = function() {
    $('.header').prepend([this.$menuTrigger, this.$backButton, this.$searchTrigger]);
    $('.header-v2').after(this.$overlay);
    return this.$body.prepend(this.$responsiveMenuWrapper);
  };

  PNResponsiveMenu.prototype.unbind = function() {
    this.$searchTrigger.off('tap');
    this.$menuTrigger.off('tap');
    this.$overlay.off('tap');
    $('.ls-resp-submenu').parent('li').off('tap');
    $('.ls-resp-submenu a').off('tap');
    return this.$menu.empty();
  };

  PNResponsiveMenu.prototype.bind = function() {
    var $navWithMenu;
    this.$searchTrigger.on('tap', (function(_this) {
      return function(e) {
        var menuVisible;
        e.preventDefault();
        e.stopImmediatePropagation();
        menuVisible = _this.getVisibility().menuVisible;
        if (menuVisible) {
          _this.hideRespMenu();
        }
        if (!menuVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!menuVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.removeClass('noscroll');
        }
        _this.$overlay.addClass('ls-resp-overlay-search-v3');
        _this.$searchTrigger.toggleClass(_this.popoverTriggerActiveClass);
        _this.$searchBar.toggleClass(_this.popoverActiveClass);
        return $('#search').focus();
      };
    })(this));
    this.$menuTrigger.on('tap', (function(_this) {
      return function(e) {
        var searchVisible;
        e.stopImmediatePropagation();
        searchVisible = _this.getVisibility().searchVisible;
        if (searchVisible) {
          _this.hideRespSearch();
        }
        if (!searchVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!searchVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.toggleClass('noscroll');
        }
        _this.$body.toggleClass('show-responsive-menu');
        _this.$overlay.removeClass('ls-resp-overlay-search-v3');
        _this.$menuTrigger.toggleClass(_this.popoverTriggerActiveClass);
        return _this.toggleAriaHidden(_this.$responsiveMenuWrapper);
      };
    })(this));
    this.$overlay.on('tap', (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.hideRespSearch();
        _this.hideRespMenu();
        return _this.hideOverlay();
      };
    })(this));
    $navWithMenu = $('.ls-resp-submenu').parent('li');
    $navWithMenu.on('tap', (function(_this) {
      return function(e) {
        var $flyout, $tab, $visibleSubnavs;
        $tab = $(e.currentTarget);
        $visibleSubnavs = _this.$subnavs.not('.hide').addClass('hide');
        $navWithMenu.removeClass('ls-resp-open-menu');
        $flyout = $tab.children('.ls-resp-submenu');
        if ($flyout.length && !$flyout.is($visibleSubnavs)) {
          $tab.addClass('ls-resp-open-menu');
          $flyout.removeClass('hide');
          return $flyout.find('.ls-lazy').lazyload();
        }
      };
    })(this));
    return $('.ls-resp-submenu a').on('tap', function(e) {
      return e.stopImmediatePropagation();
    });
  };

  PNResponsiveMenu.prototype.toggleAriaHidden = function($el) {
    var ariaHidden;
    ariaHidden = $el.attr('aria-hidden');
    ariaHidden = ariaHidden === 'true' ? 'false' : 'true';
    return $el.attr('aria-hidden', ariaHidden);
  };

  PNResponsiveMenu.prototype.getAttributes = function(elements, attribute) {
    var attributeArray, el, i, len;
    attributeArray = [];
    for (i = 0, len = elements.length; i < len; i++) {
      el = elements[i];
      attributeArray.push($(el).attr(attribute).parent('li').removeClass('ls-resp-open-menu'));
    }
    return attributeArray;
  };

  PNResponsiveMenu.prototype.getVisibility = function() {
    return {
      searchVisible: this.$searchBar.is(':visible'),
      menuVisible: this.$responsiveMenuWrapper.is(':visible')
    };
  };

  PNResponsiveMenu.prototype.hideRespSearch = function() {
    if (this.$searchBar.is(':visible')) {
      this.$searchTrigger.removeClass(this.popoverTriggerActiveClass);
      return this.$searchBar.removeClass(this.popoverActiveClass);
    }
  };

  PNResponsiveMenu.prototype.hideRespMenu = function() {
    this.$body.removeClass('show-responsive-menu');
    return this.$menuTrigger.removeClass(this.popoverTriggerActiveClass);
  };

  PNResponsiveMenu.prototype.hideOverlay = function() {
    this.$overlay.hide();
    return this.$body.removeClass('noscroll');
  };

  PNResponsiveMenu.prototype.toggleOverlay = function() {
    return this.$overlay.toggle();
  };

  PNResponsiveMenu.prototype.removeAria = function(menu, trigger) {
    return $(menu).attr({
      'aria-labelled': null,
      'aria-labelledby': null,
      'aria-hidden': null
    });
  };

  return PNResponsiveMenu;

})();

